import { Component } from '@angular/core';

@Component({
  selector: 'app-organize-rules',
  templateUrl: './organize-rules.component.html',
  styleUrl: './organize-rules.component.scss'
})
export class OrganizeRulesComponent {
  items = [
    {
      title: 'قانون تنظيم الاستيراد والتصدير',
      content: 'يعد قانون تنظيم الاستيراد والتصدير رقم 118 لسنة 1975 ثاني أهم قانون، بعد قانون الجمارك، ينظم الاستيراد والتصدير.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا لقرار وزير التجارة والصناعة رقم 784 لسنة 2010', url: 'assets/edit 2010.pdf' },
        { text: 'اضغط هنا للائحة القواعد المنفذة لأحكام قانون الاستيراد والتصدير', url: 'assets/lw 2005.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون تنمية الصادرات',
      content: 'ينص قانون تنمية الصادرات رقم 155 لسنة 2002 على مسئولية وزير التجارة الخارجية والصناعة عن إصدار القواعد والإجراءات التي تضمن زيادة الصادرات المصرية وفتح أسواق جديدة أمامها وزيادة تنافسيتها في الأسواق العالمي.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا', url: 'assets/قانون تنمية الصادرات.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون السجل التجاري',
      content: 'يتم تنظيم عملية التسجيل سواء للعملاء أو للشركات من خلال قانون السجل التجاري رقم 34 لسنة 1976 وتعديلاته (رقم 98 لسنة 1996)، والقاعدة الأساسية هي أن أي شخص مشارك في نشاط تجاري يجب أن يتم تسجيله في السجل التجاري.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا', url: 'assets/قانون السجل التجاري (1).pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون التوكيلات التجارية',
      content: 'يُعرف الوكيل التجاري طبقا لقانون التوكيلات التجارية رقم 120 لسنة 1982 (وقرار وزارة الاقتصاد رقم 342 لسنة 1982) بأنه كل شخص طبيعي أو اعتباري يقوم بتقديم العطاءات أو إبرام عمليات الشراء أو البيع أو تأجير أو تقديم الخدمات باسم و لمصلحة المنتجين أو التجار أو الموزعين، ويشترط أن يكون هذا الشخص – طبيعيًا كان أم اعتباريًا – مقيدًا في سجل الوكلاء و الوسطاء التجاريين المعد لذلك ت وزارة الاقتصاد والتجارة الخارجية',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا', url: 'assets/قانون التوكيلات التجارية.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون الجمارك',
      content: 'يقوم قانون الجمارك رقم 95 لسنة 2005 بتعديل قانون الجمارك رقم 66 لسنة 1963 بهدف توحيد الإجراءات في كل النقاط الجمركية، وإعداد وتطوير قواعد بيانات لإجراء جميع الإجراءات الجمركية من خلال الحاسب الآلي وزيادة شفافية إجراءات الإيرادات الجمركية، حيث يقوم القانون الجديد أيضاً بتعديل أجزاء من قانون الإعفاءات الجمركية رقم 186 لسنة 1986.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا لقانون رقم 14 لسنة 2004', url: 'assets/edit 14.pdf' },
        { text: 'اضغط هنا لقانون رقم 10 لسنة 2006', url: 'assets/law 10.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون حماية المنافسة ومنع الاحتكار',
      content: 'تم إصدار قانون المنافسة رقم 3 لسنة 2005 في شهر يناير2005، وتبعه إصدار لائحته التنفيذية في أغسطس من نفس العام، ويهدف القانون إلى القضاء على الممارسات الاحتكارية التي تضر بالاقتصاد الوطني وتحرم المستهلكين من حقوقهم في الحصول على سلع رخيصة وعالية الجودة، ويراعي القانون حقوق المصنعين في تعزيز وتحسين فاعليتهم الاقتصادية عن طريق الدخول إلى الأسواق العالمية.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا لقرار رئيس مجلس الوزراء رقم 2509 لسنة 2016', url: 'assets/edit 2016.pdf' },
        { text: 'اضغط هنا لقانون رقم 3 لسنة 2005', url: 'assets/law 3.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'قانون مكافحة الإغراق',
      content: 'أعلنت مصر قانون مكافحة الإغراق رقم 161 لسنة 1998 بهدف حماية الاقتصاد القومي المصري من تبعات الممارسات الضارة للتجارة الدولية، وقد أدى قانون مكافحة الإغراق إلى اتخاذ سلسة من القرارات من قبل وزارة التجارة والتموين والتي تم من خلالها فرض وتفعيل عقوبات على الإغراق.',
      mainLinksLabel: 'لقراءة المزيد عن القانون,',
      mainLinks: [
        { text: 'اضغط هنا', url: 'assets/قانون مكافحة الاغراق.pdf' }
      ],
      expanded: false,
    }
  ];

  toggle(item: any) {
    item.expanded = !item.expanded;
  }
}
